var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountClaims(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22495 9.36773V9.16311M4.22495 9.16311V19.8508C4.22495 21.2316 5.34423 22.3507 6.72495 22.3507H9.90315M4.22495 9.16311L6.56738 5.95263C7.1949 5.09255 8.1955 4.58398 9.26016 4.58398H17.9922C19.3728 4.58398 20.4922 5.70328 20.4922 7.08398V16.1487",
    stroke: "#404553",
    strokeWidth: 1.51092
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.488 14.7231V20.6751C20.488 21.5956 19.7418 22.3418 18.8213 22.3418H12.1866",
    stroke: "#404553",
    strokeWidth: 1.51092
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2333 19.3215V22.4203H9.48614L9.56041 19.3396L9.57064 18.9153L9.21211 18.688C8.49579 18.2341 7.94484 17.7867 7.56751 17.2447C7.20174 16.7192 6.96728 16.0585 6.96734 15.1186C6.96744 13.445 7.62574 12.3832 8.42311 11.7259C8.97716 11.2692 9.61164 10.9978 10.1708 10.8687V15.1186V15.8686H10.9208H12.1349H12.8849V15.1186V10.9272C14.5476 11.4351 16.0783 13.0859 16.0783 15.1186C16.0783 16.175 15.7726 16.9046 15.3505 17.4337C14.9182 17.9757 14.3249 18.3554 13.6844 18.6337L13.2333 18.8297V19.3215Z",
    fill: "#FEEE00",
    stroke: "#404553",
    strokeWidth: 1.35983
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0128 5.93921H17.2085V6.62029C17.3152 6.65411 17.418 6.69671 17.5161 6.74728L17.9914 6.27196L18.8368 7.11741L18.3643 7.58999C18.4189 7.69421 18.4645 7.80389 18.5001 7.91803H19.1872V9.09623H18.5001C18.4645 9.21034 18.419 9.32001 18.3644 9.42421L18.837 9.89686L17.9915 10.7423L17.5162 10.267C17.4181 10.3176 17.3152 10.3602 17.2085 10.394V11.075H16.0128V10.3941C15.9089 10.3613 15.8087 10.32 15.713 10.2713L15.242 10.7423L14.3965 9.89686L14.8608 9.43253C14.8043 9.32584 14.7572 9.21338 14.7207 9.09623H14.0337V7.91803H14.7208C14.7572 7.80091 14.8043 7.68848 14.8608 7.58183L14.3964 7.11741L15.2419 6.27196L15.713 6.74306C15.8087 6.69426 15.9089 6.65303 16.0128 6.62016V5.93921ZM16.611 9.23949C17.0155 9.23949 17.3434 8.91159 17.3434 8.50709C17.3434 8.10261 17.0155 7.77471 16.611 7.77471C16.2065 7.77471 15.8786 8.10261 15.8786 8.50709C15.8786 8.91159 16.2065 9.23949 16.611 9.23949Z",
    fill: "#404553"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 3.4502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountClaims);
export default __webpack_public_path__ + "static/media/accountClaims.cab91a96.svg";
export { ForwardRef as ReactComponent };